import { IBEError } from '@common/interfaces/be-error.interface';
import { ICollection } from '@common/interfaces/collection.interface';
import { createCollection } from '@common/utils/create-collection.util';
import { createBoxCustomisationProduceDto, IBoxCustomisationProduceDto } from '@src/api/model/box-customisation-produce.dto';
import { packHouseApiRequest, TPackhouseV1ProduceGetError } from '@src/api/pack-house-generated-api';
import { queryClient } from '@src/shared/query-client';
import { useQuery, UseQueryResult } from 'react-query';

const NAME = 'box-customisation-produce';

const useGetBoxCustomisationProduceList = (queryOptions: {
    enabled: boolean;
}): UseQueryResult<ICollection<IBoxCustomisationProduceDto>, IBEError<TPackhouseV1ProduceGetError>> => {
    return useQuery<ICollection<IBoxCustomisationProduceDto>, IBEError<TPackhouseV1ProduceGetError>>(
        `${NAME}-list`,
        () => {
            return packHouseApiRequest.packhouseV1ProduceGet({}).then((r) =>
                createCollection(
                    r?.data?.list?.map((item) => createBoxCustomisationProduceDto(item)),
                    0,
                    {},
                ),
            );
        },
        queryOptions,
    );
};

const getProduceListFromCache = (): ICollection<IBoxCustomisationProduceDto> | undefined => {
    return queryClient.getQueryData(`${NAME}-list`);
};

export const boxCustomisationProduce = {
    getProduceListFromCache,
    useGetBoxCustomisationProduceList,
};
